import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=4e0d42f0&"
import script from "./GroupList.vue?vue&type=script&lang=ts&"
export * from "./GroupList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupList.vue"
export default component.exports